"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftPreset = void 0;
const types_1 = require("@hoepel.app/types");
class ShiftPreset {
    constructor(props) {
        this.props = props;
    }
    get price() {
        return types_1.Price.fromCents(this.props.priceCents);
    }
    get name() {
        return this.props.name;
    }
    get childrenCanAttend() {
        return this.props.childrenCanAttend;
    }
    get crewMembersCanAttend() {
        return this.props.crewMembersCanAttend;
    }
    get location() {
        return this.props.location;
    }
    get description() {
        return this.props.description;
    }
    get startAndEndTime() {
        return new types_1.StartAndEndTime({
            start: types_1.LocalTime.fromMinutesSinceMidnight(this.props.startMinutesSinceMidnight),
            end: types_1.LocalTime.fromMinutesSinceMidnight(this.props.endMinutesSinceMidnight),
        });
    }
    static createEmpty(name) {
        return new ShiftPreset({
            priceCents: 0,
            name,
            childrenCanAttend: true,
            crewMembersCanAttend: true,
            description: '',
            location: '',
            startMinutesSinceMidnight: 540,
            endMinutesSinceMidnight: 1020, // 17:00
        });
    }
    static fromProps(props) {
        return new ShiftPreset(props);
    }
    toProps() {
        return this.props;
    }
    withName(name) {
        return ShiftPreset.fromProps({
            ...this.toProps(),
            name,
        });
    }
    withPrice(price) {
        return ShiftPreset.fromProps({
            ...this.toProps(),
            priceCents: price.totalCents,
        });
    }
    withChildrenCanAttend(childrenCanAttend) {
        return ShiftPreset.fromProps({
            ...this.toProps(),
            childrenCanAttend,
        });
    }
    withCrewMembersCanAttend(crewMembersCanAttend) {
        return ShiftPreset.fromProps({
            ...this.toProps(),
            crewMembersCanAttend,
        });
    }
    withLocation(location) {
        return ShiftPreset.fromProps({
            ...this.toProps(),
            location,
        });
    }
    withDescription(description) {
        return ShiftPreset.fromProps({
            ...this.toProps(),
            description,
        });
    }
    withStartAndEndTime(startAndEnd) {
        const startMinutesSinceMidnight = startAndEnd.start.minute + startAndEnd.start.hour * 60;
        const endMinutesSinceMidnight = startAndEnd.end.minute + startAndEnd.end.hour * 60;
        return ShiftPreset.fromProps({
            ...this.toProps(),
            startMinutesSinceMidnight,
            endMinutesSinceMidnight,
        });
    }
}
exports.ShiftPreset = ShiftPreset;
//# sourceMappingURL=shift-preset.js.map